module.exports = __webpack_public_path__ + "static/event-22-40f289e2251d78d64b4bf958ccf211e5.jpg";